import KatalLogger, { Level } from '@amzn/katal-logger';

const SSPA_REPORT_CENTER_APPLICATION_NAME = 'SSPA_REPORT_CENTER';

// The Katal Logging URL is set through MONS route which indirectly calls our API Gateway for Katal Logging
// https://monster.mons.amazon.dev/applications/UnifiedReportCenterUI
const katalLoggerConfig = {
  url: '/urc-katal-logger',
  logThreshold: Level.INFO,
  maxLogLineSize: 10000,
  logToConsole: false
};

const appContext = window.AppContext;
const katalContext = {
  marketplaceId: appContext?.marketplaceId,
  advertiserId: appContext?.advertiserId,
  entityId: appContext?.entityId,
  advertiserType: appContext?.advertiserType,
  isSpoofer: appContext?.isSpoofer,
  globalAccountId: appContext?.globalAccountId,
  locale: appContext?.locale,
  applicationName: SSPA_REPORT_CENTER_APPLICATION_NAME
};

export const katalLogger = new KatalLogger(katalLoggerConfig);
katalLogger.context = katalContext;
katalLogger.addErrorListener();
